define('view/controller/booking/datetime/slots-weekly/TimeSlotsWeeklyDayView',['require','marionette','view/controller/booking/datetime/slots-weekly/TimeSlotsWeeklyItemView','lib/view/UnwrapBehavior','Config'],function (require) {

    var Marionette = require('marionette');
    var TimeSlotsWeeklyItemView = require('view/controller/booking/datetime/slots-weekly/TimeSlotsWeeklyItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');
    var Config = require('Config');

    /**
     * Slots weekly timeline day view (container)
     *
     * @class TimeSlotsWeeklyDayView
     */
    return Marionette.CompositeView.extend({

        template: '#time_slots_weekly_day_view',
        childView: TimeSlotsWeeklyItemView,
        childViewContainer: '.sb_time_slots_weekly_day_container',
        childViewOptions: function (model, index) {
            return {
                clientTimeZone: this.getOption('clientTimeZone'),
                bookingModel: this.getOption('bookingModel')
            };
        },
        childEvents: {
            'select:time': 'onTimeSelected'
        },
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        initialize: function () {
            this.collection = this.model.get('collection');
            //console.log(this.collection);
        },

        serializeData: function () {
            var result = Marionette.CompositeView.prototype.serializeData.apply(this);
            result.time_diff = this.getOption('clientTimeZone').get('time_diff');

            var date = Date.parseMysqlDate(result.date);

            result.day_name = date.getWeekDayName('medium');
            result.is_holiday = ([0, 6].indexOf(date.getDay()) !== -1);
            result.is_empty_day = !this.collection.findWhere({'type': 'free'});
            result.is_day_off = this.getOption('isDayOff');
            result.is_wl_available = this.getOption('isWlAvailable');

            var today = new Date();
            today.setHours(0,0,0,0);
            date.setHours(0,0,0,0);
            result.is_past = date < today;

            return result;
        },
        _isWaitingListDay : function (){
            var isWlEnabled = Config.getInstance().getPluginStatus('waiting_list');
            var isEmptyDay = !this.collection.findWhere({'type': 'free'});

            if(isWlEnabled && isEmptyDay && !this.getOption('isDayOff')){
                return true;
            }
            return false;
        },

        onTimeSelected: function (view, data) {
            var model = data.model;
            if(model.get('type') !== 'free' && this._isWaitingListDay()){
                model.set('wl', true);
            }
            this.triggerMethod('select:time', data);
        }

    });

});
